import { useListToggle } from 'common/ProseInput/hooks/useListToggle'
import { schema } from 'common/ProseInput/Schema'
import { IconButton } from 'components/IconButton/IconButton'
import { FC } from 'react'
import { ListButtonProps } from './Types'
import { ReactComponent as BulletIcon } from 'assets/icons/listBulleted16.svg'
import { ReactComponent as OrderedIcon } from 'assets/icons/listNumbered16.svg'
import { observer } from 'mobx-react-lite'

const ListButton: FC<React.PropsWithChildren<ListButtonProps>> = observer(({ nodeType, children }) => {
  const { isActive, isDisabled, onPress } = useListToggle(nodeType)
  return (
    <IconButton isDisabled={isDisabled} onPress={onPress} variant={isActive ? 'toggleOn' : 'toggleOff'}>
      {children}
    </IconButton>
  )
})

export const OrderedList = () => (
  <ListButton nodeType={schema.nodes.ordered_list}>
    <OrderedIcon />
  </ListButton>
)
export const BulletList = () => (
  <ListButton nodeType={schema.nodes.bullet_list}>
    <BulletIcon />
  </ListButton>
)
